import { RoleCode } from '../models';

export interface NavItem {
  label: string;
  route: string;
  icon: 'initiation' | 'editorial' | 'production' | 'validation' | 'approval' | 'template' | 'master' | 'apiJobs';
  roles: RoleCode[];
}

/** Sidebar navigation, filtered per-user by role. Each workflow entry maps
 * to the generic /journal/:processKey route (see workflow-process.model.ts). */
export const NAV_ITEMS: NavItem[] = [
  { label: 'Journal Initiation', route: '/journal/initiation', icon: 'initiation', roles: ['project_manager_initiation', 'admin'] },
  { label: 'Editorial Journal Data', route: '/journal/editorial', icon: 'editorial', roles: ['editorial_sme', 'admin'] },
  { label: 'Production Journal Data', route: '/journal/production', icon: 'production', roles: ['production_sme', 'admin'] },
  { label: 'Journal Validation', route: '/journal/validation', icon: 'validation', roles: ['qc', 'admin'] },
  { label: 'Journal Approval', route: '/journal/approval', icon: 'approval', roles: ['project_manager_approval', 'admin'] },
  { label: 'Template Management', route: '/admin/templates', icon: 'template', roles: ['admin'] },
  { label: 'Journal Master', route: '/admin/journal-master', icon: 'master', roles: ['admin'] },
  { label: 'API Imported Jobs', route: '/admin/api-jobs', icon: 'apiJobs', roles: ['admin'] }
];
